module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a832d077dcd73b4ec6f68a2e0278fa7e.png";